module.exports = __webpack_public_path__ + "/img/LRCW-qmZjX2.svg";